"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fills = _interopRequireDefault(require("../foundational-styles/fills"));

var badgeColors = _fills.default.options;
var _default = badgeColors;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvYmFkZ2VDb2xvcnMuanMiXSwibmFtZXMiOlsiYmFkZ2VDb2xvcnMiLCJmaWxscyIsIm9wdGlvbnMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVBLElBQU1BLFdBQVcsR0FBR0MsZUFBTUMsT0FBMUI7ZUFFZUYsVyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBmaWxscyBmcm9tICcuLi9mb3VuZGF0aW9uYWwtc3R5bGVzL2ZpbGxzJ1xuXG5jb25zdCBiYWRnZUNvbG9ycyA9IGZpbGxzLm9wdGlvbnNcblxuZXhwb3J0IGRlZmF1bHQgYmFkZ2VDb2xvcnNcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/component-specific/badgeColors.js
// module id = 218
// module chunks = 0